<template>
  <v-text-field
    v-model="inputValue"
    v-bind:rules="citizenIdRules"
    outlined
    density="compact"
    :disabled="disabled"
  ></v-text-field>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";
export default {
  name: "citizenIdCard",
  props: {
    value: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    and_passport: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    objectTranslator,
  },
  data: () => ({
    citizenIdRules: [validator.required, validator.citizenIdThai],
  }),
  computed: {
    text() {
      if (this.and_passport) {
        return this.$t("info_card.citizen_id_passport");
      } else {
        return this.$t("info_card.citizen_id");
      }
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
